import {observable, action, makeObservable} from 'mobx';
class AuthLoginStore {
  @observable errorResponse = null;
  @observable isInputFocused = false;
  @observable showErrorMessage = true;

  @action
  setErrorResponse = errorResponse => (this.errorResponse = errorResponse);

  @action
  setIsInputFocused = isInputFocused => {
    this.isInputFocused = isInputFocused;
    this.showErrorMessage = true;
  };

  @action
  setShowErrorMessage = showErrorMessage => (this.showErrorMessage = showErrorMessage);

  constructor() {
    makeObservable(this);
  }
}

export default AuthLoginStore;
